
  $(document).ready(function(){
    $('.plans-toggle-switch').attr('checked', false); // Unchecks it
    $('.plans-toggle-switch').change(function() {
      $('.subscriptions-main-wrapper').toggleClass("annual-plans")
    });
  });
  $(document).ready(function() {
    var $slider = $('.slider-vert-para-for');
    var $progressBar = $('.progress');
    var $progressBarLabel = $( '.slider__label' );
    var $progressPaginationNum = $( '.pagination-num' );
    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) { 
      var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
      $progressBar
        .css('background-size', '100%' + calc + '%')
        .attr('aria-valuenow', calc );
      $progressPaginationNum.text(nextSlide+1+"/"+slick?.slideCount);
                                  });
    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      focusOnSelect: true,
      asNavFor: ".slider-vert-nav",
      fade: true,
    });  
    $(".slider-vert-nav").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: ".slider-vert-para-for",
      dots: true,
      focusOnSelect: true,
      customPaging:function(slick,current){
        console.log({slick})
      },
      responsive: [
        {
          breakpoint: 330,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        }],
    });
  });
  $(document).ready(function() {
    $(".slider-for").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: ".slider-nav",
      autoplay: true,
      autoplaySpeed: 10000,
    });
    $(".slider-nav").slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: ".slider-for",
      dots: false,
      // centerMode: true,
      prevArrow: $(".prev"),
      nextArrow: $(".next"),
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1008,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });
  const show = (element) => {
    const elementHasStyle = !!element && !!element.style;
    if (elementHasStyle) {
      element.style.display = "block";
    }
  };
  const hide = (element) => {
    const elementHasStyle = !!element && !!element.style;
    if (elementHasStyle) {
      element.style.display = "none";
    }
  };
	const signUpBtnClass = 'sign-up-btn';
	// Sign up button inside Ready to take your first step to living healthy for longer? section
  const healthySurveySignUpClass = 'healthy-survey-button';
  const isLoggedIn = document.cookie.indexOf('wf_loggedin=') !== -1;
  if (isLoggedIn) {
    //window.location.replace(window.location.href + 'user-account');
    const signUpBtns = document.getElementsByClassName(signUpBtnClass)
    const healthySurveySignUpBtn = document.getElementsByClassName(healthySurveySignUpClass)[0]
    hide(healthySurveySignUpBtn);
		for(const element of signUpBtns){
    		hide(element);
		}
  }
